export default "__VITE_ASSET__Bui0uht9__"